import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addSubscriptionPlan, blockUnblockSubscriptionPlan, deleteSubscriptionPlan, editSubscriptionPlan, subscriptionPlanListing, viewSubscriptionPlan } from "../apis/apiHandler";

export const allSubscriptionPlans = createAsyncThunk(
    'subscription/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await subscriptionPlanListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addSubscriptionPlans = createAsyncThunk(
    'subscription/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addSubscriptionPlan(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const editSubscriptionPlans = createAsyncThunk(
    'subscription/edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editSubscriptionPlan(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewSubscriptionPlanDetails = createAsyncThunk(
    'subscription/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewSubscriptionPlan(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const deleteSubsriptionPlans = createAsyncThunk(
    'subscription/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSubscriptionPlan(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const changeSubscriptionPlanStatus = createAsyncThunk(
    'subscription/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blockUnblockSubscriptionPlan(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    subscriptionPlanList: [],
    error: null,
    addSuccess: false,
    editSuccess: false,
    subscriptionPlanDetail: {},
    deleteSuccess: false,
    statusSuccess: false
};

const subscriptionPlanSlice = createSlice({
    name: 'parent',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allSubscriptionPlans.pending, (state) => {
                state.loading = true;
            })
            .addCase(allSubscriptionPlans.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subscriptionPlanList = payload?.data;
            })
            .addCase(allSubscriptionPlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addSubscriptionPlans.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
                state.error = null;
            })
            .addCase(addSubscriptionPlans.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addSubscriptionPlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addSuccess = false;
            })
            .addCase(editSubscriptionPlans.pending, (state) => {
                state.loading = true;
                state.editSuccess = false;
                state.error = null;
            })
            .addCase(editSubscriptionPlans.fulfilled, (state) => {
                state.loading = false;
                state.editSuccess = true;
            })
            .addCase(editSubscriptionPlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.editSuccess = false;
            })
            .addCase(viewSubscriptionPlanDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewSubscriptionPlanDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subscriptionPlanDetail = payload?.data;
            })
            .addCase(viewSubscriptionPlanDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteSubsriptionPlans.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
                state.error = null;
            })
            .addCase(deleteSubsriptionPlans.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteSubsriptionPlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.deleteSuccess = false;
            })
            .addCase(changeSubscriptionPlanStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(changeSubscriptionPlanStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeSubscriptionPlanStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.statusSuccess = false;
            })
    }
})

export default subscriptionPlanSlice.reducer;